import * as React from "react";
import { CSSTransition } from "react-transition-group";
import {
  Grid,
  Typography,
  withStyles,
  Snackbar,
  IconButton,
  Tabs,
  Tab,
} from "@material-ui/core";
import { observer } from "mobx-react";
import { ModelMapStore } from "modules/modelMap/ModelMapStore";
import { TakeOffStore } from "modules/takeOff/TakeOffStore";
import TakeOffTable from "modules/takeOff/components/layouts/TakeOffTable";
import TakeOffEditFormat from "modules/takeOff/components/layouts/TakeOffEditFormat";
import TakeOffTableFormat from "modules/takeOff/components/layouts/TakeOffTableFormat";
import LayerLoadingMessage from "modules/takeOff/components/layouts/LayerLoadingMessage";
import SwipeableViews from "react-swipeable-views";
import Header from "modules/takeOff/components/layouts/Header";
import i18n from "i18n";
import LayerAddModelMap from "modules/modelMap/components/layouts/LayerAddModelMap";
import LayerAddModelMapView from "modules/modelMap/components/layouts/LayerAddModelMapView";
import * as _ from "lodash";
import CloseIcon from "@material-ui/icons/Close";
import { EModelMapType } from "common/enums";

const styles = (theme) => ({
  // Loading animation
  transitionEnter: {
    opacity: 0.01,
  },
  transitionEnterActive: {
    opacity: 1,
    transition: "opacity 300ms ease-in",
  },
  transitionLeave: {
    opacity: 1,
  },
  transitionLeaveActive: {
    opacity: 0.01,
    transition: "opacity 300ms ease-in",
  },
  // Loading animation end
  container: {
    zIndex: 2,
    height: "calc(100vh - 34px)",
    display: "grid",
    gridTemplateRows: "auto 1fr",
    position: "absolute" as any,
    backgroundColor: "#FFFFFF",
  },
  headerContainer: { height: "30px", backgroundColor: "#474747" },
  line: {
    width: "100%",
    position: "absolute" as any,
    padding: 0,
    margin: 0,
    top: "79px",
  },
  topBar: { overflow: "hidden" as any },
  tabBar: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    backgroundColor: "#FFFFFF",
  },
  tabsRoot: {
    backgroundColor: "#FFFFFF",
    color: "#9E9E9E",
    boxShadow: "unset",
    width: "fit-content",
    fontSize: "12px",
  },
  tabsIndicator: {
    height: 0,
  },
  tabRoot: {
    width: 154,
    minWidth: "unset",
    border: "unset",
    fontWeight: 500,
    "&$tabSelected > :first-child": {
      borderBottom: `3px solid #9FB408`,
      fontWeight: 700,
    },
    "&:hover": {
      color: "#9FB408",
    },
    transition: "all 0.3s ease-in",
  },
  tabSelected: {
    color: "#9FB408",
  },
  tabLabelContainer: {
    padding: "0px",
  },
  tabWrapper: {
    height: "50px",
    display: "block",
    lineHeight: "50px",
    fontFamily: "Raleway",
  },
});

type IProps = {
  classes: any;
};

function TabContainer({ children }) {
  return <Typography component="div">{children}</Typography>;
}

@observer
class LayerTakeOff extends React.Component<IProps> {
  handleTabChange = (event, tab) => {
    TakeOffStore.setSwipeTab(tab);
    if (ModelMapStore.modelMapFormat.length === 0) {
      ModelMapStore.loadModelFormat();
    }
  };

  handleCloseSnack = () => {
    TakeOffStore.openSnack = false;
  };

  getTitle(): string {
    if (TakeOffStore.takeOffLoading) return "Carregando...";

    const modelMap = TakeOffStore.takeOffModelMap;
    if (modelMap) return modelMap.data.name;

    if (ModelMapStore.typeSelected === EModelMapType.ELEMENT_CONSTRUCTIVE)
      return i18n.modelMaps.addLayer.headerEC;

    return i18n.modelMaps.addLayer.headerMat;
  }

  render() {
    const { classes } = this.props;
    const { layerTakeOffList, takeOffLoading, isFormating } = TakeOffStore;

    const tabClasses = {
      root: classes.tabRoot,
      selected: classes.tabSelected,
      labelContainer: classes.tabLabelContainer,
      wrapper: classes.tabWrapper,
    };

    const modelMap = TakeOffStore.takeOffModelMap;
    const list = TakeOffStore.findFormatedListByModelMapId(
      modelMap ? modelMap.id : ""
    );

    const isEditingOrCreating = Boolean(TakeOffStore.layerTakeOffEdit);

    return (
      <CSSTransition
        in={layerTakeOffList}
        enter={true}
        exit={true}
        timeout={300}
        classNames={{
          enter: classes.transitionEnter,
          enterActive: classes.transitionEnterActive,
          exit: classes.transitionLeave,
          exitActive: classes.transitionLeaveActive,
        }}
        unmountOnExit
      >
        <Grid container className={classes.container}>
          <Grid item xs={12} className={classes.headerContainer}>
            <Header name={this.getTitle()} />
          </Grid>
          <Grid item xs={12} className={classes.tabBar}>
            <div style={{ marginLeft: 17 }}>
              <Tabs
                value={TakeOffStore.swipeTab}
                onChange={this.handleTabChange}
                classes={{
                  root: classes.tabsRoot,
                  indicator: classes.tabsIndicator,
                }}
              >
                <Tab classes={tabClasses} label={"CONFIGURAÇÃO"} />
                <Tab
                  classes={tabClasses}
                  disabled={isEditingOrCreating}
                  style={{ width: "185px" }}
                  label={
                    TakeOffStore.loadingTakeOff
                      ? `TAKE OFF ITENS (${TakeOffStore.searchMaterialOrMaterialLength})`
                      : `TAKE OFF ITENS (${TakeOffStore.takeOffFilteredItems.length})`
                  }
                />
                <Tab
                  classes={tabClasses}
                  disabled={isEditingOrCreating}
                  label={"FORMATAÇÃO"}
                />
              </Tabs>
            </div>
            <hr className={classes.line}></hr>
          </Grid>
          {takeOffLoading && (
            <LayerLoadingMessage
              saveFormate={TakeOffStore.takeOffSaveformate}
              searchTypeOrMaterial={TakeOffStore.searchMaterialOrMaterial}
              searchTypeOrMaterialLength={
                TakeOffStore.searchMaterialOrMaterialLength
              }
            />
          )}
          {!takeOffLoading && (
            <Grid item xs={12} className={classes.topBar}>
              <SwipeableViews
                animateTransitions={false}
                axis={"x"}
                index={TakeOffStore.swipeTab}
                disabled={true}
              >
                <TabContainer>
                  {isEditingOrCreating ? (
                    <LayerAddModelMap />
                  ) : (
                    <LayerAddModelMapView />
                  )}
                </TabContainer>
                <TabContainer>
                  {modelMap && TakeOffStore.swipeTab === 1 && (
                    <div style={{ height: "calc(100vh - 183px)" }}>
                      <TakeOffTable />
                    </div>
                  )}
                </TabContainer>
                <TabContainer>
                  <div
                    style={{
                      height: "calc(100vh - 113px)",
                      position: "relative",
                    }}
                  >
                    {!isFormating && list.length > 0 ? (
                      <TakeOffTableFormat />
                    ) : (
                      <TakeOffEditFormat />
                    )}
                  </div>
                </TabContainer>
              </SwipeableViews>
              <Snackbar
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                open={Boolean(TakeOffStore.openSnack)}
                onClose={this.handleCloseSnack}
                ContentProps={{
                  "aria-describedby": "message-id",
                }}
                autoHideDuration={1000}
                message={<span id="message-id">{TakeOffStore.openSnack}</span>}
                action={[
                  <IconButton
                    key="close"
                    aria-label="close"
                    color="inherit"
                    onClick={this.handleCloseSnack}
                  >
                    <CloseIcon />
                  </IconButton>,
                ]}
              />
            </Grid>
          )}
        </Grid>
      </CSSTransition>
    );
  }
}

export default withStyles(styles)(LayerTakeOff);



// WEBPACK FOOTER //
// ./src/modules/takeOff/components/LayerTakeOff.tsx